import { Badge, IconButton, Menu, MenuItem, Typography } from "@material-ui/core";
import { createCiaOrigenCookie, Link, PortalContext } from "@portal/arq-portal-core";
import { IconAlertas } from "@portal/arq-portal-core";
import React from "react";
import { makeStyles } from '@material-ui/core';
import useAlertas from "../hooks/AlertasHooks";
const useStyles = makeStyles(() => ({
  alertasMenu:{
    '& .MuiPaper-rounded': {
        borderRadius: '0px',
        marginTop: '43px',
    },
    '& .MuiListItem-button': {
        height: '30px',
        borderBottom: '1px solid #d6d8d8',
    },
    '& .MuiList-padding': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    '& .MuiMenuItem-root': {
      fontSize: '12px',
    },
  },
}))

export const AlertasButton = (props:any) =>{
    const {user, ciaGestiona} = React.useContext(PortalContext);
    const clases = useStyles(props);
    var datos = props.data;
    if(!props.data){
      if(ciaGestiona && ciaGestiona != ''){
        const {data} = useAlertas(user?user.id:"", ciaGestiona);
        datos = data;
      }
      else {
        let ciaOrigenCookie = createCiaOrigenCookie(ciaGestiona?ciaGestiona:"");
        const {data} = useAlertas(user?user.id:"", ciaOrigenCookie);
          datos = data;
      }
    }
    var alertas = datos? datos.Salida?.Alertas : [];

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    
    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null); 
    };

    var total = alertas && alertas.length > 0 ? alertas.map((x:any)=>x?.Contador <0? 0: x.Contador).reduce((a:number,b:number)=>a+b) : 0;
    if (total < 0) total = 0;
    return <React.Fragment>
       
        <IconButton {...props} onClick={handleMenu} aria-label="Alertas">
            <Badge color="secondary" badgeContent={total} max={99} showZero>
                <IconAlertas></IconAlertas>
            </Badge>
        </IconButton>
        
        <Menu 
                className={clases.alertasMenu}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={open}
                onClose={handleClose}
              >
                {!alertas&&<Typography variant="body1" style={{ padding: "0px 18px", maxWidth: "150px", textAlign: "center"}}>No se han recuperado alertas</Typography>}
                {alertas&&alertas.map((alerta:any, indx:number)=>
                {
                return alerta && alerta.Contador >= 0 &&
                    <MenuItem key={indx} onClick={handleClose} component={Link} to={alerta.UrlAcceso}>
                      <Typography style={{flex: "1"}} variant="inherit">{alerta.Titulo}</Typography>
                      <span style={{float: "right", paddingLeft:"24px", color:"#dc0028"}}>{alerta.Contador}</span>
                    </MenuItem>
                }
                )}                
              </Menu>
    </React.Fragment>;
}